export const LEGAL_CONTRACTUAL_INFORMATION: string = `

### <!--= ++sectionIndex -->. Contractual Information

These Terms of Service constitute an agreement between you and us. The following information identifies the parties to this agreement:

<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

Phone / WhatsApp Business: <!--= company.phone -->
E-Mail: <!--= company.mail -->

Managing Director(s)
<!-- for (const director of company.directors) { -->
<!--= director -->
<!-- } -->

Register Court: <!--= company.court -->
Register Number: <!--= company.courtNumber -->

Value Added Tax Identification Number (VAT ID): <!--= company.vat -->

Questions about these Terms should be sent to us through mail.
`;
